import React from "react";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { getComputedLayout } from "components/Topology/computedLayout/getComputedLayout";
import { useStructuredTopology } from "objs/_ConfiguratorObjs/Wizard/stores/wizardStore";
import { StaticLayoutRenderer } from "components/Topology/staticLayer/StaticLayoutRenderer";
import { PreviewHeader } from "./PreviewHeader";

export const PreviewTopology = ({ wizardTitle, selectedZoneIdx, innerRef }) => {
  const structuredTopology = useStructuredTopology();

  const printLayout = getComputedLayout({
    structuredTopology,
    selectedZoneIdx: selectedZoneIdx ?? null,
    isPrint: true,
  });

  return (
    <TransformWrapper minScale={0.1} maxScale={3} wheel={{ step: 0.04 }}>
      <TransformComponent wrapperClass="mh-100 mw-100 w-100 p-3 overflow-hidden position-absolute">
        <PreviewHeader wizardTitle={wizardTitle} />
        <div
          id="printTopologyIdWrapperId"
          ref={innerRef}
          style={{
            position: "relative",
            width: `${printLayout.width}px`,
            height: `${printLayout.height}px`,
          }}
        >
          <StaticLayoutRenderer layout={printLayout} isPrint={true} />
        </div>
      </TransformComponent>
    </TransformWrapper>
  );
};
